export default "__VITE_ASSET__DFnLe_Fu__"